define(function (require) {
    'use strict';

    var Marionette = require('marionette');
    var popover = require('behaviors/popover');
    var modal = require('behaviors/modal');
    var TasksModel = require('models/tasks');
    var I18n = require('i18n!nls/main');
    var StaffCollection = require('collections/staffs');

    var mainTpl = require('text!tmpls/parts/tasks/main.tpl').default;
    var itemTpl = require('text!tmpls/parts/tasks/tasks_item.tpl').default;

    var EmptyView = require('parts/rightbar_empty');
    var ts = require('system/libs/timestamp2');
    var $ = require('jquery');
    var _ = require('underscore');
    var AppConfig = require("config/application");

    var TasksItem = Marionette.ItemView.extend({
        template: itemTpl,
        model: TasksModel,
        initialize: function () {
            this.listenTo(this.model, 'change:complete_task', this.completeTask);
        },

        onRender: function () {
            this.binding = app.Rivets.bind(this.el, {model: this.model});
        },

        completeTask: function () {
            var that = this;
            var id = that.model.id;
            app.message.confirm('Завершить задачу?', function () {
                that.model.set('complete', true);
                that.$('div[data-id="' + id + '"]').addClass('complete');

                that.model.save(app.Collections.Tasks, {
                    success: 'Задача завершена',
                    error: 'Задача не завершена'
                });

                app.Vents.trigger('tasks:complete');
            });
        }
    });

    var TasksCollectionView = Marionette.CollectionView.extend({childView: TasksItem});

    var Collection = Backbone.Collection.extend({model: TasksModel});

    return Marionette.LayoutView.extend({
        template: mainTpl,

        regions: {
            regionToday: '#js-region-tasks-today',
            regionTomorrow: '#js-region-tasks-tomorrow',
            regionOverdue: '#js-region-tasks-overdue',
            regionEmpty: '#js-region-empty'
        },

        newBehaviors: {},

        _view: {
            today: {},
            tomorrow: {},
            overdue: {}
        },

        parentBehaviors: {
            'popover': {
                behaviorClass: popover
            },
            'modal': {
                behaviorClass: modal
            }
        },

        ui: {
            'btnNotepad': '.js-btn-notepad',
            'volumeToggle': '.js-right-sidebar-volume',
            'filterSingleProject': '.js-tasks-right-single-project',
            'filterAllProjects': '.js-tasks-right-all-projects',
            'toggleHideShow': '.js-tasks-right-toggle',
        },

        events: {
            'click @ui.btnNotepad': 'showNotepad',
            'click @ui.volumeToggle': 'volumeToggle',
            'click @ui.filterSingleProject': 'filterSingleProject',
            'click @ui.filterAllProjects': 'filterAllProjects',
            'click @ui.toggleHideShow': 'toggleHideShow',
            'change select': 'filterStaff'
        },

        behaviors: function () {
            return _.extend({}, this.parentBehaviors, this.newBehaviors);
        },

        serializeData: function () {
            var that = this;

            return {
                show_today: that.todayCollection.length > 0,
                show_tomorrow: that.tomorrowCollection.length,
                show_overdue: that.overdueCollection.length > 0,
                count_today: that.todayCollection.length,
                count_tomorrow: that.tomorrowCollection.length,
                count_overdue: that.overdueCollection.length,
                volume_off: $.cookie('LPT_right-sidebar-volume') == 'off'
            };
        },

        initialize: function () {
            var that = this;

            that.filter_staff = 0;
            that.filter_project = 0;

            that.todayCollection = new Collection();
            that.tomorrowCollection = new Collection();
            that.overdueCollection = new Collection();

            that.collection = new Collection(app.Collections.Tasks.toJSON());

            if (typeof app.Collections.StaffList === 'undefined') {
                app.Collections.StaffList = new StaffCollection();
                app.Collections.StaffList.fetch();
                that.listenTo(app.Collections.StaffList, 'sync', that.separateCollections);
            } else {
                that.separateCollections();
            }
        },

        onRender: function () {
            var that = this;

            that._view['today'] = new TasksCollectionView({collection: that.todayCollection});
            that.regionToday.show(that._view['today']);

            that._view['tomorrow'] = new TasksCollectionView({collection: that.tomorrowCollection});
            that.regionTomorrow.show(that._view['tomorrow']);

            that._view['overdue'] = new TasksCollectionView({collection: that.overdueCollection});
            that.regionOverdue.show(that._view['overdue']);

            if (that.project_toggle) {
                $('.js-tasks-right-single-project').addClass('active');
                $('.js-tasks-right-all-projects').removeClass('active');
            }
            else {
                $('.js-tasks-right-single-project').removeClass('active');
                $('.js-tasks-right-all-projects').addClass('active');
            }

            that.$el.lptSetter();
            that.appendStaff();
        },

        appendStaff: function () {
            var data = [];
            var obj = {
                id: 0,
                text: '-'
            };
            data.push(obj);
            _.each(app.Collections.StaffList.models, function (model) {
                obj = {
                    id: model.get('id'),
                    text: model.get('name')
                };
                data.push(obj);
            });

            this.$('.select2').select2({
                placeholder: I18n.tasks.select_label,
                data: data
            });
        },

        /*
         * Разделение коллекции на три    
         */
        separateCollections: function () {
            var that = this;
            var filter_staff = [], filter_project = [];

            that.todayCollection.reset();
            that.tomorrowCollection.reset();
            that.overdueCollection.reset();

            if (that.filter_staff == 0) {
                that.collection = new Collection(app.Collections.Tasks.toJSON());
            } else {
                filter_staff = that.collection.where({
                    owner_id: that.filter_staff
                });
                that.collection.reset(filter_staff);
            }

            if (that.filter_project != 0) {
                filter_project = that.collection.where({
                    project_id: that.filter_project
                });
                that.collection.reset(filter_project);
            }

            that.setData(that.collection.models);
            that.setOwnerName(that.collection.models);

            if (that.collection.length != 0) {
                _.each(that.collection.models, function (model, i) {
                    that.filterDate(model.get('date_end'), model.id);
                });

                that.$('.b-tasks-right__body').show();

                that.render();

                that.$el.lptSetter();
                that.appendStaff();
            } else {
                that.regionEmpty.show(new EmptyView());
                that.$('.b-tasks-right__body').hide();
            }
        },

        /**
         * [setModelDate] - с сервера приходит дата модели в формате таймштампа
         * присваеваем локальной модели дату в нужном формате
         * @param {[object]} collection - коллекция задач
         */
        setData: function (collection) {
            var end;
            _.each(collection, function (model) {
                end = app.Utils.moment.unix(model.get('date_end'));
                model.set('end_date', end.format(AppConfig.locale.date_format));
                model.set('end_time', end.format(AppConfig.locale.time_format_min));
            });
        },

        /**
         * Если задача была создана от главного аккаунта
         * и у нее id "main"
         * то заменяем ее айдишником текущего пользователя из
         * коллекции StaffList
         */
        setOwnerName: function (collection) {
            var staff_model;

            _.each(collection, function (model, i) {

                staff_model = app.Collections.StaffList.get(model.get('owner_id'));
                model.set({'owner_name': staff_model.get('name')}, {silent: true});
            });
        },

        /* 
         * метод заполняет три коллекции:
         * - задания на сегодня (that.todayCollection)
         * - задания на завтра  (that.tomorrowCollection)
         * - просроченые задания(that.overdueCollection)
         * принимает параметры:
         * - timestamp - timestamp текущей модели (дата окончания таска)
         * - index      - индекс модели в коллекции
         */
        filterDate: function (timestamp, index) {
            var that = this;

            var today = app.Utils.moment();
            var tomorrow = app.Utils.moment().add(1, 'days');

            var today_start = ts(today.format(AppConfig.locale.date_format) + ' 00:00:00');
            var today_end = ts(today.format(AppConfig.locale.date_format) + ' 23:59:59');

            var tomorrow_start = ts(tomorrow.format(AppConfig.locale.date_format) + ' 00:00:00');
            var tomorrow_end = ts(tomorrow.format(AppConfig.locale.date_format) + ' 23:59:59');

            if (timestamp > today_start && timestamp < today_end) {
                this.todayCollection.push(that.collection.get(index));
            }
            else if (timestamp > tomorrow_start && timestamp < tomorrow_end) {
                this.tomorrowCollection.push(that.collection.get(index));
            }
            else if (timestamp < today_start) {
                this.overdueCollection.push(that.collection.get(index));
            }
        },

        /*
         * Включить \ выключить звук
         */
        volumeToggle: function (e) {
            var that = $(e.currentTarget);
            if (that.hasClass('fa-volume-up')) {
                that.removeClass('fa-volume-up').addClass('fa-volume-off');
                $.cookie('LPT_right-sidebar-volume', 'off');
            }
            else {
                that.removeClass('fa-volume-off').addClass('fa-volume-up');
                $.cookie('LPT_right-sidebar-volume', 'on');
            }
        },

        /*
         * Переключалка на блокнот    
         */
        showNotepad: function (e) {
            e.preventDefault();
            $.cookie('LPT_right-sidebar', 'notepad');
            app.regionRightSidebar.show(new app.Sidebars.Notepad());
            $('#right-sidebar').children('div').addClass('notepadBackground');
        },

        /*
         * Фильтр по всем проектам    
         */
        filterAllProjects: function (e) {
            var that = this;
            that.project_toggle = false;
            that.filter_project = 0;

            $.cookie('LPT_right-sidebar-project', 'all');

            that.separateCollections();
        },

        /*
         * Фильтр по текущему проекту    
         */
        filterSingleProject: function (e) {
            var that = this;

            that.project_toggle = true;
            that.filter_project = app.Models.curProject.id;

            $.cookie('LPT_right-sidebar-project', 'current');

            that.separateCollections();
        },

        /*
         * Скрыть \ показать задачи   
         */
        toggleHideShow: function (e) {
            var current = $(e.currentTarget);
            if (current.is('span')) {
                current.children('span').toggle();
                current.parent().next('.js-tasks-right-content').toggle();
                return;
            }
            else if (current.is('div')) {
                current.children('span').children('span').toggle();
                current.next('.js-tasks-right-content').toggle();
            }
        },

        filterStaff: function () {
            this.filter_staff = parseInt(this.$('.select2').val());
            this.separateCollections();
        }
    });

});
